import { invoiceType as type } from '@/helpers/enums';
import * as types from '../mutation-types';
import { unionState } from '../union-state'

const state = {
	simplified_buy_invoices: [],
	simplified_sale_invoices: [],
	buyRefundInvoices: [],
	saleRefundInvoices: [],
	buy_invoice: {},
	sale_invoice: {},
};

const actions = {
	fetchAll({ commit }, invoiceType) {
		return window.axios.get(`MaterialFlow/Invoices/${invoiceType}`,{
			params:{
				fromDate: new Date('2019-01-01').toISOString().slice(0, 10),
				toDate: new Date ().toISOString().slice(0, 10)
			}
		}
		).then(response => {
			if(invoiceType == type.buy)
				commit(types.STORE_SIMPLIFIED_BUY_INVOICES, response.data);
			else if(invoiceType == type.sale)
				commit(types.STORE_SIMPLIFIED_SALE_INVOICES, response.data);
			else if(invoiceType == type.saleRefund)
				commit(types.STORE_SIMPLIFIED_SALE_REFUND_INVOICES, response.data);
			else if(invoiceType == type.buyRefund)
				commit(types.STORE_SIMPLIFIED_BUY_REFUND_INVOICES, response.data);
			return response.data
		});
    },
    
	fetch({ commit }, { invoiceId, invoiceType }) {
		return window.axios.get(`MaterialFlow/Invoices/${invoiceType}/${invoiceId}`).then(response => {
            if(invoiceType == type.buy)
                commit(types.STORE_ONE_BUY_INVOICE, response.data);

            else if(invoiceType == type.sale)
                commit(types.STORE_ONE_SALE_INVOICE, response.data);

			return response.data;
		});
	},
	fetchInvoiceByNumber({ commit }, { invoiceType, invoiceNo }) {
		return window.axios.get(`MaterialFlow/Invoices/${invoiceType}/ByNo/${invoiceNo}`).then(response => {
			if(invoiceType == type.buy)
                commit(types.STORE_ONE_BUY_INVOICE, response.data);

            else if(invoiceType == type.sale)
                commit(types.STORE_ONE_SALE_INVOICE, response.data);

			return response.data;
		});
	},

	create({ commit }, {invoiceType, invoice}) {
		return window.axios.post(`MaterialFlow/Invoices/${invoiceType}`, invoice).then(response => {
            if(invoiceType == type.buy)
            {
                commit(types.STORE_ONE_BUY_INVOICE, response.data);
                commit(types.STORE_ONE_SIMPLIFIED_BUY_INVOICE, response.data)
            }    

            else if(invoiceType == type.sale)
            {
                commit(types.STORE_ONE_SALE_INVOICE, response.data);
                commit(types.STORE_ONE_SIMPLIFIED_SALE_INVOICE, response.data)
            }    

			return response.data;
		});
	},
    update({ commit }, { invoiceId, invoiceType, invoice}) {
		return window.axios.put(`MaterialFlow/Invoices/${invoiceType}/${invoiceId}`, invoice)
		.then(response => {
			if(invoiceType == type.buy)
            {
                commit(types.STORE_ONE_BUY_INVOICE, response.data);
                commit(types.STORE_ONE_SIMPLIFIED_BUY_INVOICE, response.data)
            }    

            else if(invoiceType == type.sale)
            {
                commit(types.STORE_ONE_SALE_INVOICE, response.data);
                commit(types.STORE_ONE_SIMPLIFIED_SALE_INVOICE, response.data)
            } 
			return response.data;
		});
	},

	updateToPosted({ commit }, { invoiceId, invoiceType}) {
		return window.axios.put(`MaterialFlow/Invoices/${invoiceType}/${invoiceId}/ChangeToPosted`)
		.then(response => {
			if(invoiceType == type.buy)
				commit(types.STORE_ONE_SIMPLIFIED_BUY_INVOICE, response.data)

			else if(invoiceType == type.sale)
				commit(types.STORE_ONE_SIMPLIFIED_SALE_INVOICE, response.data)

			return response.data;
		});
	},

	updateToNotPosted({ commit }, { invoiceId, invoiceType}) {
		return window.axios.put(`MaterialFlow/Invoices/${invoiceType}/${invoiceId}/ChangeToNotPosted`)
		.then(response => {
			if(invoiceType == type.buy)
				commit(types.STORE_ONE_SIMPLIFIED_BUY_INVOICE, response.data)

			else if(invoiceType == type.sale)
				commit(types.STORE_ONE_SIMPLIFIED_SALE_INVOICE, response.data)

			return response.data;
		});
	},

    createEntry({ commit }, { invoiceId, invoiceType, invoiceEntry}) {
		return window.axios.post(`MaterialFlow/Invoices/${invoiceType}/${invoiceId}/Entries`, invoiceEntry)
		.then(response => {
			if(invoiceType == type.buy)
                commit(types.STORE_ONE_BUY_INVOICE_ENTRY, response.data);

            else if(invoiceType == type.sale)
                commit(types.STORE_ONE_SALE_INVOICE_ENTRY, response.data);

			return response.data;
		});
	},

	updateEntry(vuexContext, { invoiceId, invoiceType, invoiceEntry}) {
		return window.axios.put(`MaterialFlow/Invoices/${invoiceType}/${invoiceId}/Entries/${invoiceEntry.id}`, invoiceEntry)
		.then(response => {
			return response.data;
		});
	},

	deleteEntry(vuexContext, { invoiceId, invoiceType, invoiceEntryId}) {
		return window.axios.delete(`MaterialFlow/Invoices/${invoiceType}/${invoiceId}/Entries/${invoiceEntryId}`);
	},

	delete({ commit }, { invoiceId, invoiceType }) {
		return window.axios.delete(`MaterialFlow/Invoices/${invoiceType}/${invoiceId}`).then(response => {
			if(invoiceType == type.buy)
				commit(types.DELETE_SIMPLIFIED_BUY_INVOICE, response.data)
			else if(invoiceType == type.sale)
				commit(types.DELETE_SIMPLIFIED_SALE_INVOICE, response.data)
		});
	},

	fetchEntry({ commit }, { id, invoiceType }) {
		return window.axios.get(`MaterialFlow/invoices/InvoiceEntries/${id}`).then(response => {
            if(invoiceType == type.buy)
				commit(types.STORE_ONE_BUY_INVOICE_ENTRY, response.data)

			else if(invoiceType == type.sale)
				commit(types.STORE_ONE_SALE_INVOICE_ENTRY, response.data)

			return response.data;
		});
	},
	fetchInvoiceType({ commit }, { invoiceId }) {
		return window.axios.get(`MaterialFlow/Invoices/${invoiceId}/Type`).then(response => {
				commit('', '')
			return response.data;
		});
	},
	// warehouses 
	fetchInvoicesNoPosted(_, { invoiceType }) {
		return window.axios.get(`/MaterialFlow/Invoices/${invoiceType}/NotPosted`).then(({data}) => {
			return data
		})
	}
};

const mutations = {
    [types.STORE_ONE_BUY_INVOICE](state, invoice) {
		state.buy_invoice = invoice;
	},
    [types.STORE_ONE_SALE_INVOICE](state, invoice) {
		state.sale_invoice = invoice;
	},
    [types.STORE_SIMPLIFIED_BUY_INVOICES](state, simplified_buy_invoices) {
		state.simplified_buy_invoices = simplified_buy_invoices;
	},
	[types.STORE_ONE_SIMPLIFIED_BUY_INVOICE](state, simplified_buy_invoice) {
		state.simplified_buy_invoices = unionState(state.simplified_buy_invoices, [simplified_buy_invoice]);
	},
	[types.DELETE_SIMPLIFIED_BUY_INVOICE](state, simplified_buy_invoice) {
		state.simplified_buy_invoices = unionState(state.simplified_buy_invoices, [simplified_buy_invoice]);
	},
	[types.STORE_SIMPLIFIED_SALE_INVOICES](state, simplified_sale_invoices) {
		state.simplified_sale_invoices = simplified_sale_invoices;
	},
	[types.STORE_ONE_SIMPLIFIED_SALE_INVOICE](state, simplified_sale_invoice) {
		state.simplified_sale_invoices = unionState(state.simplified_sale_invoices, [simplified_sale_invoice]);
	},
	[types.DELETE_SIMPLIFIED_SALE_INVOICE](state, simplified_sale_invoice) {
		state.simplified_sale_invoices = unionState(state.simplified_sale_invoices, [simplified_sale_invoice]);
	},
	[types.STORE_ONE_BUY_INVOICE_ENTRY](state, invoice_entry) {
		state.buy_invoice.invoice_entries = unionState(state.buy_invoice.invoice_entries, [invoice_entry]);
	},
    [types.STORE_ONE_SALE_INVOICE_ENTRY](state, invoice_entry) {
		state.sale_invoice.invoice_entries = unionState(state.sale_invoice.invoice_entries, [invoice_entry]);
	},

	[types.STORE_SIMPLIFIED_SALE_REFUND_INVOICES](state, saleRefundInvoices) {
		state.saleRefundInvoices = saleRefundInvoices;
	},
	[types.STORE_SIMPLIFIED_BUY_REFUND_INVOICES](state,  buyRefundInvoices) {
		state.buyRefundInvoices = buyRefundInvoices;
	},
};

const getters = {};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};

